import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCurrency, getAccountTypes } from "../../connectors/transactionsApi";
import { AccountTypeData, TransactionCurrencyData } from "../../types/types";
import {
  parseAccountType,
  parseCurrency,
} from "../../pages/TransactionPage/utils";

interface TransactionResourcesState {
  currencyData: TransactionCurrencyData[];
  accountTypesData: AccountTypeData[];
  isLoading: boolean;
}

export const fetchTransactionResources = createAsyncThunk<
  { currencyData: TransactionCurrencyData[]; accountTypesData: AccountTypeData[] },
  void,
  { rejectValue: string }
>(
  "transactionResources/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const [currencyResponse, accountTypesResponse] = await Promise.all([
        getCurrency(),
        getAccountTypes(),
      ]);
      return {
        currencyData: parseCurrency(currencyResponse),
        accountTypesData: parseAccountType(accountTypesResponse),
      };
    } catch {
      return rejectWithValue("Error al cargar recursos de transferencia");
    }
  },
);

const initialState: TransactionResourcesState = {
  currencyData: [],
  accountTypesData: [],
  isLoading: false,
};

const transactionResourcesSlice = createSlice({
  name: "transactionResources",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactionResources.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTransactionResources.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currencyData = action.payload.currencyData;
        state.accountTypesData = action.payload.accountTypesData;
      })
      .addCase(fetchTransactionResources.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default transactionResourcesSlice.reducer;
